import AdminLayout from "../../../components/organisms/adminLayout";
import DataGridBox from "../../../components/organisms/dataGrid";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModesModel,
  GridRowParams,
  GridRowsProp,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid";
import React, { useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import AdminPageFilters from "../../../components/organisms/adminPageFilters";
import {
  useBulkUpdateFeatureMutation,
  useCreateFeatureMutation,
  useDeleteFeatureMutation,
  useGetFeatureQuery,
  useHardDeleteFeatureMutation,
  useUpdateFeatureMutation,
} from "../../../api/filters/feature";
import {
  Deactivatepopup,
  DeletePopup,
} from "../../../components/molecules/DeleteModal";
import { EditModal } from "../../../components/molecules/EditModal";
import { InputFieldV2 } from "../../../components/atoms/inputField";
import { ButtonV1 } from "../../../components/atoms/button";
import snackbar from "../../../api/snackbar/useSnackbar";
import { Check, Close } from "@mui/icons-material";

interface Item {
  _id: string;
  title: string;
  active: boolean;
}

function FeaturePage() {
  const [rows, setRows] = React.useState<GridRowsProp>([]);
  const [isDelete, setDelete] = React.useState(false);
  const [isEdit, setEdit] = React.useState(false);
  const [isAddNew, setAddNew] = React.useState(false);
  const [Feature, setFeature] = React.useState("");
  const [regex, setRegex] = React.useState<string>("");
  const [sortType, setSortType] = React.useState<string>("createdAt");
  const [updateType, setUpdateType] = React.useState<string>("createdAt");
  // const [filterType, setFilterType] = React.useState<string>("active");
  const [sortOrder, setSortOrder] = React.useState<Number>(-1);
  const [isDeactivate, setDeactivate] = React.useState<boolean>(false);
  const [currentId, setCurrentId] = React.useState<GridRowId>("");
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>();
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });

  const {
    data: FeatureData,
    isFetching: FeatureIsFetching,
    isSuccess: FeatureSuccess,
  } = useGetFeatureQuery({
    searchKeyword: regex,
    pageSize: paginationModel.pageSize,
    pageNo: paginationModel.page + 1,
    sortType: sortType,
    sortOrder: sortType === "title" ? 1 : sortOrder,
    scope: 'admin',
  });
  const [update, { isLoading: updateIsLoading, isSuccess: updateSuccess }] =
    useUpdateFeatureMutation({});

  const [
    bulkUpdateData,
    {
      data: bulkUpdatedData,
      isLoading: isbulkUpdatedLoading,
      isSuccess: isbulkUpdatedSuccess,
    },
  ] = useBulkUpdateFeatureMutation({});

  const [create, { isLoading: createIsLoading, isSuccess: createSuccess }] =
    useCreateFeatureMutation({});
  const [
    deleteFeature,
    { isLoading: deleteIsLoading, isSuccess: deleteSuccess },
  ] = useDeleteFeatureMutation({});

  const [
    hardDeleteFeature,
    { isLoading: hardDeleteIsLoading, isSuccess: hardDeleteSuccess },
  ] = useHardDeleteFeatureMutation({});

  const handleStatus = (id: GridRowId) => () => {
    setDeactivate((old: boolean) => !old);
    setCurrentId(id);
    console.log(id);
  };

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "Name", width: 250 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 180,
      cellClassName: "actions",
      getActions: ({ id }: GridRowParams<any>) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon className="text-blue-400" />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon className="text-red-400" />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  useEffect(() => {
    if (FeatureSuccess && FeatureData) {
      setRows(
        FeatureData.data.data
          ?.filter((item: Item) => item?._id)
          ?.map((item: Item) => ({
            id: item._id,
            name: item.title,
            // status: item.active,
          }))
      );
    }
  }, [FeatureData, FeatureIsFetching, FeatureSuccess]);

  const handleCreateClick = () => {
    setAddNew(true);
  };

  const handleEditClick = (id: GridRowId) => () => {
    setEdit(true);
    setCurrentId(id);
    console.log(id);
  };

  const handleDeleteClick = (id: GridRowId) => () => {
    setDelete(true);
    setCurrentId(id);
    console.log(id);
  };

  const [selectedRowIds, setSelectedRowIds] = React.useState<GridRowId[]>([]);

  const handleSelectionChange = (newSelection: GridRowId[]) => {
    console.log(newSelection);
    setSelectedRowIds(newSelection);
  };

  function handleCreate(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    create({ title: Feature })
      .unwrap()
      .then((res) => {
        console.log(res);
        snackbar.success(res.message);
        setAddNew(false);
      })
      .catch((error) => {
        console.log(error);
        snackbar.error(error?.data?.message);
      });
  }

  function handleUpdate(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    update({ id: currentId, body: { title: Feature } })
      .unwrap()
      .then((res) => {
        console.log(res);
        snackbar.success(res.message);
        setEdit(false);
      })
      .catch((error) => {
        console.log(error);
        snackbar.error(error?.data?.message);
      });
  }

  const handleSoftDelete = () => {
    deleteFeature({ id: currentId })
      .unwrap()
      .then((res) => {
        setDeactivate(false);
        console.log(res);
        snackbar.success(res.message);
      })
      .catch((error) => {
        setDeactivate(false);
        console.log(error);
        snackbar.error(error?.data?.message);
      });
  };

  function handleDelete() {
    hardDeleteFeature({ id: currentId })
      .unwrap()
      .then((res) => {
        console.log(res);
        snackbar.success(res.message);
        setDelete(false);
      })
      .catch((error) => {
        console.log(error);
        snackbar.error(error?.data?.message);
        setDelete(false);
      });
  }

  function bulkUpdate() {
    console.log(updateType);

    let data;
    if (updateType === "delete") {
      data = { active: false };
    }
    bulkUpdateData({ id: selectedRowIds, data })
      .unwrap()
      .then((res) => {
        console.log(res);
        snackbar.success(res.message);
        setUpdateType("");
      })
      .catch((error) => {
        console.log(error);
        snackbar.error(error?.data?.message);
        setUpdateType("");
      });
  }

  return (
    <AdminLayout>
      <AdminPageFilters
        name="Feature"
        qty={FeatureData?.data?.totalCount}
        setAddNew={handleCreateClick}
        setRegex={setRegex}
        bulkUpdate={bulkUpdate}
        setUpdateType={setUpdateType}
        sortType={sortType}
        setSortType={setSortType}
        regex={regex}
      />
      {FeatureData?.data?.totalCount === 0 ? (
        <div className="flex flex-col items-center justify-center mt-20">
          <iframe src="https://lottie.host/embed/1e9daa48-f32d-4038-a6bd-9b541e0c6d65/0uPBH4JAkp.lottie"></iframe>
          <p className="text-gray-500 text-lg font-semibold">
            No Features found.
          </p>
          <p className="text-gray-400 mt-1">
            Try changing your filters or add a new Feature.
          </p>
          <ButtonV1 className="px-10 w-max my-8" color="blue" setActive={() => setAddNew(true)}>
            Add new
          </ButtonV1>
        </div>
      ) : (
        <DataGridBox
          columns={columns}
          initialRows={rows}
          rowModesModel={rowModesModel}
          selectedRowIds={selectedRowIds}
          paginationModel={paginationModel}
          setRowModesModel={setRowModesModel}
          qty={FeatureData?.data?.totalCount}
          setPaginationModel={setPaginationModel}
          onSelectionModelChange={handleSelectionChange}
        />
      )}
      {isDeactivate && (
        <Deactivatepopup
          open={isDeactivate}
          handleClose={() => setDeactivate(false)}
          handleDelete={() => handleSoftDelete()}
          message="Are sure to update the status ?"
        />
      )}
      {isDelete && (
        <DeletePopup
          open={isDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
        />
      )}
      {isEdit && (
        <EditModal open={isEdit} handleClose={() => setEdit(false)}>
          <form className="flex flex-col" onSubmit={(e) => handleUpdate(e)}>
            <h1 className="text-lg font-medium mb-4 w-full">Edit Feature</h1>
            <InputFieldV2
              name="title"
              label="Name of Feature"
              type="text"
              handleChange={setFeature}
              value={rows.find((item) => item.id === currentId)?.name}
            />
            <ButtonV1 color="blue" type="submit">
              Update
            </ButtonV1>
          </form>
        </EditModal>
      )}
      {isAddNew && (
        <EditModal open={isAddNew} handleClose={() => setAddNew(false)}>
          <form className="flex flex-col" onSubmit={(e) => handleCreate(e)}>
            <h1 className="text-lg font-medium mb-4 w-full">Edit Feature</h1>
            <InputFieldV2
              name="title"
              label="Name of Feature"
              type="text"
              placeholder="Add new Feature"
              handleChange={setFeature}
            />
            <ButtonV1 color="blue" type="submit">
              Add Feature
            </ButtonV1>
          </form>
        </EditModal>
      )}
    </AdminLayout>
  );
}

export default FeaturePage;
